import React from 'react'
import ListComponentProto from './list-proto'


export default function renderListInFormNew(id:string, props:any) {
    return (
        <ListComponentProto
            renderMode="form-new"
            id={id}
            {...props}
        />
    )
}
